import { render, staticRenderFns } from "./rankingList.vue?vue&type=template&id=bb393e00&scoped=true&"
import script from "./rankingList.vue?vue&type=script&lang=js&"
export * from "./rankingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb393e00",
  null
  
)

component.options.__file = "rankingList.vue"
export default component.exports